export default {
  // #region首页
  main_collection_function: '收藏功能',
  main_menu_bar_management: '菜單欄管理',
  main_menu_export_menu_permission: '導出菜單權限',
  main_menu_view_permission: '查看權限',
  main_menu_change: '菜單調整',
  main_menu_change_tips: '下載調整前後的菜單對應關係，如有問題請反饋小雲工單，我們將會跟進處理',
  main_menu_change_confirm: '好的，知道了',

  // #endregion

  // #region 菜单
  // #region 下载中心
  main_menu_download_center: '下載中心',
  // #endregion
  // #region 客服系统菜单
  main_menu_icms_system: '客服系統',
  main_menu_icms_Intelligent_system: '智能客服系統',
  main_menu_icms_work_order: '客服工單',
  main_menu_icms_create_work_order: '創建工單',
  main_menu_icms_order_list: '工單列表',
  main_menu_icms_task_list: '任務列表',
  main_menu_icms_export_order_list: '導入結果查詢',
  main_menu_icms_export_order_list_details: '導入結果查詢詳情',
  main_menu_icms_template_settings: '模板設置',
  main_menu_icms_route_management: '路由管理',
  main_menu_icms_factor_list: '因子管理',
  main_menu_icms_basic_data_list: '基礎數據維護',
  main_menu_icms_task_list_detail: '任務列表詳情',
  main_menu_icms_order_list_detail: '工單列表詳情',
  main_menu_icms_mission_list_detail: '任務詳情',
  main_menu_icms_payment_order_detail: '理賠詳情',
  main_menu_icms_yun_order_detail: '小雲工單詳情',
  main_menu_icms_import_payment_order_detail: '導入理賠結果查詢詳情',
  main_menu_icms_data_report: '數據報表',
  main_menu_icms_status_flow_report: '狀態流轉表',
  main_menu_icms_issue_type_report: '問題類型統計表',
  main_menu_icms_source_report: '來源統計表',
  main_menu_icms_work_order_reply_report: '工單回覆統計表',
  main_menu_icms_process_management: '流程管理',
  main_menu_icms_process_update: '流程編輯',
  main_menu_icms_process_create: '流程新增',
  main_menu_icms_process_view: '流程查看',
  main_menu_icms_process_ticket: '快捷查單',
  main_menu_icms_my_work_order: '我的工單',
  main_menu_icms_oversea_piece: '海外段工單',
  main_menu_icms_other_piece: '其他工單',
  main_menu_icms_advice_complaint: '諮詢/查件/投訴',
  main_menu_icms_work_question: '問題件',
  main_menu_icms_advice_complaint_details: '諮詢/查件/投訴詳情',
  // #endregion
  // #region 消息投递菜单
  main_menu_middleware: '中間件',
  main_menu_middleware_message_delivery: '消息投遞',
  main_menu_middleware_message_subscribe: '消息服務監控',
  main_menu_middleware_message_topic: '消息主題',
  main_menu_middleware_terminal: '終端管理',
  main_menu_middleware_loserate: '消息主題詳情',
  // #endregion
  // #region 数据分发
  main_menu_middleware_data_distribution: '數據分發',
  main_menu_middleware_dataSourceList: '訂閱列表',
  main_menu_middleware_api_route: 'API路由管理',
  // #endregion
  // #region 资源管理
  main_menu_rcms_resource_management: '資源管理',
  main_menu_rcms_channel_manage: '渠道管理',
  main_menu_rcms_delivery_manage: '派送渠道管理',
  main_menu_rcms_area_manage: '場地資源管理',
  main_menu_rcms_operating_outlet: '操作網點管理',
  main_menu_rcms_airport: '機場管理',
  main_menu_rcms_harbor: '港口管理',
  main_menu_rcms_port: '口岸管理',
  main_menu_rcms_transport_manage: '運力資源管理',
  main_menu_rcms_air_manage: '空運資源管理',
  main_menu_rcms_car_manage: '車輛管理',
  main_menu_rcms_push_record: '推送記錄',
  main_menu_rcms_export_detail: '導出詳情',
  // #endregion
  // #region 日志监控
  main_menu_server_log_monitor: '日誌監控',
  main_menu_server_audit_log: '審計日誌',
  main_menu_server_business_log: '業務日誌',
  main_menu_server_application_log: '應用日誌',
  // #endregion
  // #region 用户中心
  main_menu_usercenter_system: '用戶中心管理系統',
  main_menu_usercenter: '用戶中心',
  main_menu_usercenter_notice_manage: '公告與消息管理',
  // #endregion
  // #region 权限管理
  main_menu_permission_title: '權限管理',
  main_menu_permission_site_authorization: '網站權限管理',
  main_menu_permission_clients_menu: '菜單和按鈕管理',
  main_menu_permission_role: '角色管理',
  main_menu_permission_dimension: '數據權限',
  main_menu_permission_site_userControl: '用戶列表',
  main_menu_permission_user_authorization: '用戶授權管理',
  main_menu_permission_resource_management: '數據資源管理',
  main_menu_permission_operation_log_permission: '操作日誌-權限',
  main_menu_permission_user_import: '用戶批量導入',
  // #endregion
  // #region 网站管理
  main_menu_permission_menu_manage: '網站管理',
  main_menu_permission_menu_list: '網站菜單管理',
  main_menu_permission_route_list: '網站頁面管理',
  // #endregion
  // #region 用户管理
  main_menu_permission_user_management: '用戶管理',
  main_menu_permission_post_manager: '職位管理',
  main_menu_permission_user_login_log: '用戶登錄日誌',
  main_menu_permission_operation_log_employee: '操作日誌-用戶',
  // #endregion
  // #region 组织机构管理
  main_menu_permission_organization_management: '組織機構管理',
  main_menu_permission_subtree: '子樹管理',
  main_menu_permission_subtree_detail: '子樹管理詳情',
  main_menu_permission_signing_node_belongs: '節點所屬簽約主體',
  main_menu_permission_base_organization: '基礎樹管理',
  main_menu_permission_operation_log_institution: '操作日誌-組織機構',
  main_menu_permission_resource_detail: '資源授權',
  main_menu_permission_role_details: '角色詳情頁',
  main_menu_permission_role_resource_authorization: '角色資源授權',
  main_menu_permission_role_authorization: '角色授權管理',
  // #endregion
  // #region 基础数据
  main_menu_basicdata_title: '基礎數據',
  main_menu_basicdata_table_meta_data: '表元數據',
  main_menu_basicdata_word_statistics: '詞條統計',
  main_menu_basicdata_word_manage: '詞條管理',
  main_menu_basicdata_public_manage: '基礎數據列表',
  main_menu_basicdata_key_manage: '秘鑰管理',
  main_menu_basicdata_web_wordstatistics: '前端詞條統計',
  main_menu_basicdata_web_wordmanage: '前端詞條管理',
  // ==== 基础数据ant =====
  main_menu_antbasicdata_title: '基礎數據(ant)',
  main_menu_antbasicdata_table_meta_data: '表元數據',
  main_menu_antbasicdata_word_statistics: '詞條統計',
  main_menu_antbasicdata_word_manage: '詞條管理',
  main_menu_antbasicdata_public_manage: '基礎數據列表',
  main_menu_antbasicdata_key_manage: '秘鑰管理',
  main_menu_antbasicdata_web_wordstatistics: '前端詞條統計',
  main_menu_antbasicdata_web_wordmanage: '前端詞條管理',
  // #endregion
  // #region 小云工单
  main_menu_business_title: '小雲工單',
  main_menu_business_workorder: '小雲工單列表',
  main_menu_business_form_type: '小雲工單類型',
  main_menu_business_form_template: '小雲工單表單模板庫',
  main_menu_business_route: '小雲工單路由規則',
  main_menu_business_staffs: '小雲工單成員管理',
  main_menu_business_schedule: '小雲工單工作日配置',
  main_menu_business_report_title: '小雲工單統計信息',
  main_menu_business_report_order: '工單統計信息',
  main_menu_business_export_order: '工單導出信息',
  main_menu_business_statistics: '工單詳情信息',
  main_menu_business_notice: '小雲工單公告',
  // #endregion
  // #region 运维工单
  main_menu_business_owos_ops: '運維工單',
  main_menu_business_owos_ops_form_type: '運維工單類型',
  main_menu_business_owos_ops_form_template: '運維工單表單模板庫',
  main_menu_business_owos_ops_workorder: '運維工單列表',
  main_menu_business_owos_ops_route: '運維工單路由規則',
  main_menu_business_owos_ops_staffs: '運維工單成員管理',
  main_menu_business_owos_ops_report: '運維工單統計信息',
  // #endregion
  // #region 需求管理
  main_menu_business_require_management: '需求管理',
  main_menu_business_require_create: '創建需求',
  main_menu_business_require_kanban: '需求看板',
  main_menu_business_require_business: '業務需求池',
  main_menu_business_require_product: '產品需求池',
  main_menu_business_require_record: 'TAPD流轉記錄',
  main_menu_business_require_help: '幫助中心',
  main_menu_business_require_detail: '需求詳情',
  main_menu_business_require_edit: '編輯需求',
  main_menu_business_require_system: '需求系統管理',
  main_menu_business_require_organization: '需求組織結構',
  main_menu_business_require_people: '需求人員管理',
  // #endregion
  // #region 服务器管理
  main_menu_server_list: '服務器管理',
  // #endregion
  // #region 服务商账号管理
  main_menu_ctms_title: '服務商賬號管理',
  main_menu_ctms_account_manage: '賬號管理',
  main_menu_ctms_login_log: '登錄日誌',
  // #endregion
  // #region 航空提货
  main_menu_ctms_air_delivery: '航空提貨',
  main_menu_ctms_port_delivery: '進港提貨',
  main_menu_ctms_order_manage: '提單管理',
  main_menu_ctms_NOA_manage: 'NOA管理',
  main_menu_ctms_pickup_task_manage: '進港提貨任務管理',
  main_menu_ctms_exception_manage: '進港提貨異常管理',
  main_menu_ctms_backlog_manage: '航空提貨待辦任務',
  // #endregion
  // #region 资源组管理
  main_menu_resource_title: '資源組管理',
  main_menu_resource_workbench: '資源組工作台',
  main_menu_resource_cost_board: '資源成本看板',
  main_menu_resource_application_modify: '資源申請',
  main_menu_resource_apply_list: '資源申請列表',
  main_menu_resource_group_details: '資源申請詳情',
  main_menu_resource_hardware_specification: '硬件配置管理',
  main_menu_resource_middleware_type: '中間件類型管理',
  main_menu_resource_entrypoint: '接入點管理',
  main_menu_resource_load_balancer: '負載均衡器',
  main_menu_resource_cluster: '集群管理',
  main_menu_resource_environment: '環境管理',
  main_menu_resource_middleground: '研發中心',
  main_menu_resource_system: '系統管理',
  main_menu_resource_system_detail: '系統資源詳情',
  main_menu_resource_preview: '資源預覽頁',
  // #endregion
  // #region Deploy3
  main_menu_deploy_title: 'Deploy3',
  main_menu_deploy_real_time: '部署實時統計',
  main_menu_deploy_statistics: '部署統計',
  main_menu_deploy_application: '應用管理',
  main_menu_deploy_deployment: '部署管理',
  main_menu_deploy_deployment_detail: '部署詳情',
  main_menu_deploy_relationship: '關係管理',
  main_menu_deploy_deployment_status: '部署狀態',
  main_menu_deploy_frontend_deploy: '前端包管理網站',
  main_menu_deploy_frontend_deploy_detail: '前端包管理詳情',
  main_menu_deploy_app_manage_system: '系統信息',
  // #endregion
  // #region 轨迹管理-tis
  main_menu_tis_new_trajectory_system: '新版TIS軌跡系統',
  main_menu_tis_title: '軌跡管理',
  main_menu_tis_search: '軌跡查詢',
  main_menu_tis_track_query_list: '軌跡查詢列表',
  main_menu_tis_track_archiving: '歸檔軌跡查詢',
  main_menu_tis_add_track_approval: '編輯軌跡審核',
  main_menu_tis_track_repair_result: '軌跡修復結果查詢',
  main_menu_tis_aging_standard: '標準時效配置',
  main_menu_tis_monitor_statistics: '軌跡節點監控',
  main_menu_tis_numbers_relation: '軌跡單號關聯',
  main_menu_tis_dataDownload: 'TIS數據下載中心',
  main_menu_tis_unmatcNode: '未匹配節點查詢',
  main_menu_tis_configuration_management: '軌跡配置管理',
  main_menu_tis_facilitator: 'TIS服務商管理',
  main_menu_tis_channel: 'TIS渠道管理',
  main_menu_tis_tracking_node: '軌跡節點管理',
  main_menu_tis_track_business: '軌跡業務階段管理',
  main_menu_tis_track_examine: '服務商軌跡規則審核',
  main_menu_tis_track_subscription_managemeent: '軌跡訂閱管理',
  main_menu_tis_track_query_listDes: '操作事件詳情',
  main_menu_tis_track_query_listDesOut: '外部軌跡詳情',
  main_menu_tis_track_view_fbaChild: '查看FBA子單',
  main_menu_tis_channel_relation: '裝箱渠道與TIS渠道關聯',
  main_menu_tis_node_deployment: 'TIS與LTS節點配置',
  main_menu_tis_track_config: '軌跡策略配置',
  main_menu_tis_awb_query: '雲頌軌跡查詢',
  main_menu_tis_awb_detail: '雲頌軌跡詳情',
  main_menu_tis_awb_management: '雲頌軌跡管理',
  main_menu_tis_track_notification: '軌跡通知管理',
  main_menu_tis_report_analysis: '軌跡報表分析',
  main_menu_tis_timeliness_report: '軌跡及時率報表',
  main_menu_tis_timeliness_details: '及時率異常明細',
  main_menu_tis_general_query: '軌跡通用查詢',
  main_menu_tis_push_config: '軌跡對外配置',
  main_menu_tis_push_monitor: '軌跡推送監控',
  main_menu_tis_flight_info: '航班信息配置',
  // #endregion
  // #region 工作台管理
  main_menu_wfs_work_system: '工作台系統',
  main_menu_wfs_title: '工作台管理',
  main_menu_wfs_workbench_management: '後端管理',
  main_menu_wfs_module_manage: '模塊管理',
  main_menu_wfs_data_manage: '數據流管理',
  main_menu_wfs_shortcut_manage: '快捷入口管理',
  main_menu_wfs_system_setting: '系統設置',
  main_menu_wfs_type_manage: '業務類型管理',
  main_menu_wfs_priority_manage: '優先級管理',
  main_menu_wfs_config_center: '配置中心',
  main_menu_wfs_message_record: '站內信記錄查詢',
  main_menu_wfs_station_message: '站內信管理',
  main_menu_wfs_saturation_factor: '飽和率配置',
  main_menu_wfs_items: '事項配置',
  main_menu_wfs_dictionary: '數據配置',
  main_menu_wfs_clearance_manager: '清關單證管理者',
  main_menu_wfs_batch_process: '批量處理',
  main_menu_wfs_complaint_deal: '轉辦處理',
  main_menu_wfs_todo_center: '待辦中心',
  main_menu_wfs_message: '消息提醒',
  main_menu_wfs_create_quick: '創建快捷',
  main_menu_wfs_quick_setting: '快捷入口設置',
  // #endregion
  // #region 工单系统
  main_menu_wos_title: '工單系統',
  main_menu_wos_workbench: '工作台',
  main_menu_wos_rule: '基礎數據維護',
  main_menu_wos_import_result: '導入結果查詢',
  main_menu_wos_work_type: '工單類型維護',
  main_menu_wos_question: '問題件工單',
  main_menu_wos_add_rule: '添加規則',
  main_menu_wos_import_detail: '導入詳情',
  main_menu_wos_import_result_detail: '導入結果明細',
  main_menu_wos_qs_order_detail: '問題件工單詳情',
  main_menu_wos_no_forest_order_detail: '無預報工單詳情',
  main_menu_wos_forest_order_detail: '預報工單詳情',
  main_menu_wos_custom_order_detail: '關務工單詳情',
  main_menu_wos_bill_order_detail: '計費問題件工單詳情',
  main_menu_wos_ots_order_detail: 'OTS無數據工單詳情',
  main_menu_wos_return_order_detail: '海外退件工單詳情',
  main_menu_wos_self_order_detail: '自取件工單詳情',
  main_menu_wos_board_return_order_detail: '海外退件未識別工單詳情',
  main_menu_wos_board_transfer_order_detail: '中轉攔截工單詳情',
  main_menu_wos_board_exist_order_detail: '進出口工單詳情',
  main_menu_wos_return_redispatch_channel: '退件重派渠道',
  main_menu_wos_abnormal_bill: '異常提單查詢',
  main_menu_wos_my_work_order: '我的工單',
  main_menu_wos_oversea_piece: '海外段工單',
  main_menu_wos_work_question: '問題件',
  main_menu_wos_advice_complaint: '諮詢/查件/投訴',
  main_menu_wos_advice_complaint_details: '諮詢/查件/投訴詳情',
  main_menu_wos_workbench_new: '工作台',
  main_menu_wos_other_order: '其他工單',
  // #endregion
  // #region 提成返点
  main_menu_crms_title: '提成返點',
  main_menu_crms_object_bind: '對象綁定管理',
  main_menu_crms_bill_data: '賬單數據管理',
  main_menu_crms_rebate_bill: '返點賬單管理',
  main_menu_crms_bill_download: '賬單下載',
  main_menu_crms_rule_config: '規則配置管理',
  // #endregion
  // #region 网上订单管理
  main_menu_oms_order_list: '網上訂單管理',
  // #endregion
  // #region 计划任务
  main_menu_cron_planing_list: '計劃任務',
  // #endregion
  // #region 客户端管理
  main_menu_client_title: '客戶端管理',
  main_menu_client_aisle: '通道列表',
  main_menu_client_instance: '實例列表',
  main_menu_client_key: '激活碼列表',
  main_menu_client_apply: '申請列表',
  main_menu_client_apply_detail: '申請列表詳情',
  main_menu_client_server: '服務端配置',
  // #endregion
  // #region 航空竞价
  main_menu_rbs_title: '航空競價',
  main_menu_rbs_list: '競價列表',
  main_menu_rbs_create_rule: '資源生成規則',
  main_menu_rbs_assess: '評估管理列表',
  main_menu_rbs_assess_details_post: '評估詳情',
  main_menu_rbs_audit: '項目結果終審列表',
  main_menu_rbs_audit_details_post: '終審詳情',
  main_menu_rbs_capacity: '項目資源管理列表',
  main_menu_rbs_capacity_resource_list: '資源列表詳情',
  // #endregion
  // #region 前端词条管理
  main_menu_tsn_title: '前端詞條管理',
  main_menu_tsn_system: '前端詞條系統管理',
  main_menu_tsn_log: '前端詞條維護日誌',
  main_menu_tsn_translation: '前端詞條列表',
  main_menu_tsn_wordstatistics: '前端詞條統計',
  main_menu_tsn_basicData: '基礎數據管理',
  // #endregion
  // #region 项目立项管理
  main_menu_pms_project_management_system: '項目管理系統',
  main_menu_pms_title: '項目立項管理',
  main_menu_pms_projectList: '項目列表',
  main_menu_pms_dashboard: '項目看板',
  main_menu_pms_projectList_form: '項目立項詳情',
  main_menu_IT_portal: 'IT門戶',
  main_menu_basic_framework: '基礎框架管理系統',
  main_menu_customer_management_system: '客戶積分管理系統',
  main_menu_route_login: '登錄',
  main_menu_route_work_title: '工作台',
  main_menu_route_find_password: '找回密碼',
  // #endregion
  // #region 网络规划
  main_menu_lnms_network_plan_management: '網絡規劃管理',
  main_menu_lnms_shift_manage: '班次管理',
  main_menu_lnms_collect_shift_manage: '攬收班次管理',
  main_menu_lnms_customs_shift_manage: '關務班次管理',
  main_menu_lnms_combination_shift_manage: '組合班次管理',
  main_menu_lnms_operation_shift_manage: '操作班次管理',
  main_menu_lnms_transport_shift_manage: '運輸班次管理',
  main_menu_lnms_airline_shift_manage: '空運班次管理',
  main_menu_lnms_truck_shift_manage: '陸運班次管理',
  main_menu_lnms_delivery_shift_manage: '派送班次管理',
  main_menu_lnms_route_manage: '路由管理',
  main_menu_lnms_route_list: '路由列表',
  main_menu_lnms_product_route_list: '產品路由列表',
  main_menu_lnms_basic_data_list: '基礎數據管理',
  main_menu_lnms_attribute_list: '屬性管理',
  main_menu_lnms_constraint_list: '約束管理',
  main_menu_lnms_route_template_list: '線路模板管理',
  main_menu_lnms_direction_of_destination: '目的流向',
  main_menu_lnms_import_list: '導入列表',
  main_menu_lnms_export_list: '導出列表',
  // #endregion
  // #region 陆运管理系统
  main_menu_ltms_Land_transport_management_system: '陸運管理系統',
  main_menu_ltms_transportation_management: '運輸管理',
  main_menu_ltms_transport_demand: '運輸需求',
  main_menu_ltms_transport_order: '運輸訂單',
  main_menu_ltms_transport_task: '運輸任務',
  main_menu_ltms_basic_data: '基礎數據',
  main_menu_ltms_customer_management: '客戶管理',
  main_menu_ltms_address_management: '地址管理',
  main_menu_ltms_carrier_management: '承運商管理',
  main_menu_ltms_carrier_priority_rules: '承運商優先級規則',
  main_menu_ltms_line_management: '線路管理',
  main_menu_ltms_carrier_quote: '承運商報價',
  main_menu_ltms_system_management: '系統管理',
  main_menu_ltms_platform_management: '平台管理',
  main_menu_ltms_mail_management: '郵件管理',
  main_menu_ltms_mail_list: '郵件列表',
  main_menu_ltms_mail_setting: '郵件配置',
  main_menu_ltms_check_bill: '賬單核對',
  main_menu_ltms_estimated_cost: '預估費用',
  main_menu_ltms_import_bill: '賬單導入',
  main_menu_ltms_bill_checked: '已核對賬單',
  main_menu_ltms_evaluation_management: '詢價管理',
  main_menu_ltms_tevaluation_demand: '詢價需求',
  // #endregion
  // #endregion

  // #region Header
  main_header_recent_visit: '最近訪問',
  main_header_placeholder: '搜索',
  main_header_IT_system: 'IT 系統',
  main_header_todo_center: '待辦中心',
  main_header_message_remind: '消息提醒',
  main_header_change_SYS_password: '修改密碼',
  main_header_log_out: '退出登錄',
  main_header_log_out_tip: '確認退出嗎？',
  main_header_log_out_title: '退出提示',
  main_header_confirm: '確定',
  main_header_cancel: '取消',
  main_header_change_name: '姓名',
  main_header_change_Work_number: '工號',
  main_header_old_password: '舊密碼',
  main_header_old_password_placeholder: '請輸入初始密碼',
  main_header_new_password: '新密碼',
  main_header_new_password_placeholder: '請輸入新密碼',
  main_header_confirm_password: '確認密碼',
  main_header_confirm_password_placeholder: '請確認密碼',
  main_header_messageObj_prompt: '提示',
  main_header_messageObj_length: '密碼長度需為8~16位',
  main_header_messageObj_three_condition: '需滿足大小寫字母、數字、特殊符號其中3種或以上',
  main_header_messageObj_no_repeat: '不允許連續或重複3位以上數字（如345、333）',
  main_header_messageObj_old_new_different: '新舊密碼不能相同',
  main_header_messageObj_twice_different: '兩次輸入密碼需一致',
  main_header_change_success: '修改成功',
  main_header_refresh: '刷新',
  main_header_close: '關閉',
  main_header_close_all: '全部關閉',
  main_header_close_addition: '除此之外全部關閉',
  main_header_close_right: '當前頁右側全部關閉',
  main_header_close_left: '當前頁左側全部關閉',
  // #endregion

  // #region 首页
  main_home_home_name: '首頁',
  main_home_todo_title: '我的待辦',
  main_home_todo_more: '更多',
  main_home_todo_checkAll: '全選',
  main_home_todo_batchProcess: '批量處理',
  main_home_todo_complaint: '轉辦',
  main_home_todo_approve: '審批通過',
  main_home_todo_reject: '駁回',
  main_home_todo_toDealWith: '去處理',
  main_home_todo_work_dealed: '恭喜你，你已處理完工作！',
  main_home_todo_no_data: '暫無數據',
  main_home_todo_current_select: '當前已選中',
  main_home_todo_data_num: '條數據',
  main_home_todo_all: '全部',
  main_home_todo_approve_tip: '該數據確定審批通過？',
  main_home_todo_approve_title: '審批通過',
  main_home_todo_confirm: '確定',
  main_home_todo_cancel: '取消',
  main_home_todo_approve_success: '審批通過！',
  main_home_todo_reject_title: '駁回處理',
  main_home_todo_reject_reason: '請填寫駁回的原因',
  main_home_todo_reject_success: '駁回處理成功!',
  main_home_quick_title: '快捷入口',
  main_home_quick_create: '創建快捷',
  main_home_quick_cancel_common: '取消常用',
  main_home_quick_set_common: '設為常用',
  main_home_quick_sort: '排序',
  main_home_quick_recommend: '設為推薦應用',
  main_home_quick_add_common: '添加常用',
  main_home_quick_no_data: '暫無數據',
  main_home_quick_cancel_common_success: '取消常用成功！',
  main_home_quick_set_common_success: '設置常用成功！',
  main_home_quick_recommend_success: '設置為推薦應用成功！',
  main_home_report_transhipment: '轉運-空運',
  main_home_report_no_data: '暫無數據',
  main_home_report_clearance: '關務-清關資料',
  main_home_report_risk_control: '關務-風控',
  main_home_micro_loading: '系統加載中...',
  main_header_full_screen: '全屏',
  main_header_forced_refresh: '強制刷新',

  // #endregion

  // #region request tips
  main_request_tip_exist_environ: '環境不存在',
  main_request_tip_login_expired: '登錄已過期，請重新登錄',
  main_request_tip_no_legal: '沒有權限，請聯繫管理員',
  main_request_tip_server_error: '服務端錯誤，請聯繫管理員',
  main_request_504_error: '網關超時，請重試',
  main_request_tip_system_error: '系統錯誤，請聯繫管理員',
  main_request_tip_timeout: '請求超時，請刷新重試',
  main_request_copy_success: '複製成功',
  main_request_tip_confirm: '確定',
  main_request_tip_cancel: '取消',
  main_request_tip_delete_success: '刪除成功',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: '歡迎登錄星雲系統',
  main_login_loading_failure: '環境加載失敗，請刷新重試',
  main_login_morning_greetings: '早上好',
  main_login_noon_greetings: '中午好',
  main_login_afternoon_greetings: '下午好',
  main_login_night_greetings: '晚上好',
  main_login_account: '賬號',
  main_login_placeholder_input: '請輸入',
  main_login_password: '密碼',
  main_login_retrieve_password: '找回密碼',
  main_login_btn_text: '登錄',
  main_login_account_tip: '請輸入賬號',
  main_login_password_tip: '請輸入密碼',
  main_login_accountMap_LDAP: '域',
  main_login_accountMap_SYS: '星雲系統',
  main_login_accountMap_CAS: '縱騰內網',
  main_login_account_error: '賬號密碼錯誤',
  main_login_retrieve_back: '返回',
  main_login_select_account: '選擇要找回的賬號',
  main_login_select_way: '選擇找回方式',
  main_login_authentication: '身份驗證',
  main_login_reset_password: '重置密碼',
  main_login_work_number: '工號',
  main_login_work_number_tip: '請輸入要找回的工號',
  main_login_customer_tip: '您正在對',
  main_login_operation_tip: '進行重置密碼操作',
  main_login_verification_code: '點擊獲取驗證碼，郵件將發送至郵箱',
  main_login_verification_code_tip: '請輸入驗證碼',
  main_login_send_verification_code: '發送驗證碼',
  main_login_name: '姓名',
  main_login_new_password: '新密碼',
  main_login_new_password_tip: '請輸入新密碼',
  main_login_new_password_again_tip: '再次輸入新密碼',
  main_login_next_step: '下一步',
  main_login_save: '保存',
  main_login_reset_password_succeeded: '重置密碼成功，請重新登錄',
  main_login_work_number_input: '請輸入工號',
  main_login_six_verification_code: '請輸入6位驗證碼',
  main_login_mail: '通過郵箱',
  main_login_unknown_way: '未知的驗證方式',
  main_login_get_in: '正在進入系統，請耐心等待',
  main_login_no_exist_page: '您沒權限或者該頁面不存在',
  main_login_no_exist_page_tip: '請檢查路徑是否正確，或者點擊按鈕返回首頁，如有問題請聯繫管理員',
  main_login_no_exist_back: '返回首頁',
  main_login_no_last_back: '返回上一頁',
  // #endregion

  // #region 物流控制塔-lct
  main_menu_lct: '物流控制塔',
  main_menu_lct_basic_data: '基礎數據',
  main_menu_lct_ware_op: '庫內操作時效標準',
  main_menu_lct_ware_tr: '倉間中轉時效標準',
  main_menu_lct_ware_de: '倉庫交貨時效標準',
  main_menu_lct_flight_exce: '航班異常時效標準',
  main_menu_lct_noa_exce: 'NOA異常時效標準',
  main_menu_lct_customs_clear: '清關異常時效標準',
  main_menu_lct_pick_up: '提貨異常時效標準',
  main_menu_lct_exce_type: '異常類型維護',
  main_menu_lct_exce_relation: '查看關係',
  main_menu_lct_report: '實時監控',
  main_menu_lct_report_port: '口岸轉運監控',
  main_menu_lct_report_ware_work: '倉庫運作監控',
  main_menu_lct_report_ware_tr: '倉間中轉監控',
  main_menu_lct_report_de_service: '交服務商監控',
  main_menu_lct_report_overseas: '海外轉運監控',
  main_menu_lct_report_exce: '運營分析',
  main_menu_lct_report_exce_ab: '異常提單監控',
  main_menu_lct_report_exce_type: '抵達到提取環節',
  main_menu_lct_flight_arrive: '航班抵達監控',
  main_menu_lct_pickup_notice: '提貨通知監控',
  main_menu_lct_airport_pickup: '機場提貨監控',
  main_menu_lct_pickup_in_warehouse: '提貨入倉監控',
  main_menu_lct_clearance_link: '清關環節監控',
  main_menu_lct_oversea_all_link: '海外轉運全鏈路監控',
  main_menu_lct_transfer_between_warehouse: '倉間中轉監控',
  main_menu_lct_warehouse_work: '倉庫運作監控',
  main_menu_lct_end_of_delivery: '交貨末端監控',
  main_menu_lct_end_of_pickup: '末端提取監控',
  main_menu_lct_link_board: '監控看板',
  main_menu_lct_delivery_monitor: '妥投達標率報表',
  main_menu_lct_delivery_link_monitor: '妥投環節監控',
  main_menu_lct_delivery_to_arrive: '發貨到抵達環節',
  main_menu_lct_take_off_monitor: '航班起飛監控',
  main_menu_lct_take_off_standard: '航班起飛時效標準',
  main_menu_lct_link_real_time_monitoring: '環節實時監控',
  main_menu_lct_run_analysis_report: '運營分析報表',
  main_menu_lct_aging_standard_configuration: '時效標準配置',
  main_menu_lct_pass_machine_standard: '過機發貨時效標準',
  main_menu_lct_pass_machine_monitor: '過機發貨監控',
  main_menu_lct_dispatch_arrive_monitor: '到港環節監控',
  main_menu_lct_dispatch_arrive_standard: '發貨到港時效標準',
  main_menu_lct_pass_link: '過機環節監控',
  main_menu_lct_checkout_time_limit_standard: '簽出過機時效標準',
  main_menu_lct_package_checkout_monitoring: '包裹簽出監控',
  main_menu_lct_shared_monitoring: '共享質控日報表',
  // #endregion
  // #region 订单履约管理-ofp
  main_menu_ofp: '訂單履約管理',
  main_menu_ofp_basic_info_manage: '基礎信息管理',
  main_menu_ofp_task_manage: '任務管理',
  main_menu_ofp_e_directory_manage: '異常目錄管理',
  main_menu_ofp_e_type_manage: '異常類型管理',
  main_menu_ofp_task_type_manage: '任務類型管理',
  main_menu_ofp_service_type_manage: '服務類型管理',
  main_menu_ofp_due_manage: '正向履約管理',
  main_menu_ofp_order_task_manage: '訂單任務管理',
  main_menu_ofp_abnormal_ofp_manage: '異常履約管理',
  main_menu_ofp_e_task_manage: '異常任務管理',
  main_menu_ofp_e_task_details: '異常任務詳情',
  main_menu_ofp_abnormal_manage: '異常管理',
  main_menu_ofp_block_import: '攔截導入',
  main_menu_ofp_e_task_query: '異常任務查詢',
  main_menu_ofp_abnormal_manage_old: '異常管理(舊)',
  main_menu_ofp_e_task_query_old: '異常任務查詢(舊)',
  main_menu_ofp_abnormal_details: '異常詳情',
  main_menu_ofp_abnormal_details_old: '異常詳情(舊)',
  main_menu_ofp_rules_manage: '履約規則管理',
  main_menu_ofp_e_process_manage: '異常流程管理',
  main_menu_ofp_edit_e_process: '編輯異常流程',
  main_menu_ofp_add_e_process: '新增異常流程',
  main_menu_ofp_view_e_process: '查看異常流程',
  main_menu_ofp_create_rules: '訂單任務生成規則',
  main_menu_ofp_distribute_rules: '任務下發規則',
  main_menu_ofp_forward_task_manage: '正向任務管理',
  main_menu_ofp_process_processing: '履約流程處理',
  main_menu_ofp_process_processing_details: '流程處理詳情',
  main_menu_ofp_task_instance: '履約任務實例',
  main_menu_ofp_task_instance_details: '任務實例詳情',
  main_menu_ofp_performance_process_manage: '履約流程管理',
  main_menu_ofp_block_import_cancel: '攔截導入和取消',
  main_menu_ofp_import_detail_page: '攔截導入明細',
  // #endregion

  // #region 运输管理系统
  main_menu_tms_Transport_management_system: '運輸管理系統',
  main_menu_tms_transportation_management: '運輸管理',
  main_menu_tms_transport_demand: '運輸需求',
  main_menu_tms_transport_order: '運輸訂單',
  main_menu_tms_transport_task: '運輸任務',
  main_menu_tms_basic_data: '基礎數據',
  main_menu_tms_line_management: '線路管理',
  main_menu_tms_mail_management: '郵件管理',
  main_menu_tms_mail_list: '郵件列表',
  main_menu_tms_mail_setting: '郵件配置',
  // #endregion

  // #region 运输资源管理系统
  main_menu_lrms_Land_resource_management_system: '運輸資源管理系統',
  main_menu_lrms_basic_data: '基礎數據',
  main_menu_lrms_address_management: '地址管理',
  main_menu_lrms_carrier_management: '承運商管理',
  main_menu_lrms_carrier_priority_rules: '承運商優先級規則',
  main_menu_lrms_carrier_quote: '承運商報價',
  main_menu_lrms_mail_management: '郵件管理',
  main_menu_lrms_mail_list: '郵件列表',
  main_menu_lrms_mail_setting: '郵件配置',
  main_menu_lrms_evaluation_management: '詢價管理',
  main_menu_lrms_tevaluation_demand: '詢價需求',
  // #endregion
  // #region 理赔系统
  main_menu_css_claims_reason: '配置賠償原因',
  main_menu_css_region_setting: '配置大區及責任部門',
  main_menu_css_special_reason_setting: '理賠單維護',
  main_menu_css_special_reason_list: '特殊理賠列表',
  main_menu_css_customer_service: '客戶服務',
  main_menu_css_basicdata_title: '基礎數據',
  main_menu_css_claims_type: '配置賠償類型',
  main_menu_css_import_record: '導推記錄',
  main_menu_css_batch_import: '批量理賠單導入',
  main_menu_css_standard_list: '標準理賠列表',
  main_css_link_setting: '配置環節'
  // #endregion
}
